/* ------------------------- External Dependencies -------------------------- */
import React from 'react'
import styled from 'styled-components'

/* ------------------------------- Component -------------------------------- */
const SpotlightViewport = ({Component}, props) => !Component ? null : Component

/* ---------------------------- Export Package ------------------------------ */
export default SpotlightViewport


// WEBPACK FOOTER //
// ./src/interface/containers/spotlight/SpotlightViewport/render/index.js